export default "__VITE_ASSET__BkU7nCV9__"